import React, { useState, useEffect } from 'react';
import { getDoc, doc, getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import Button from '../common/Button'; // Importando o botão genérico

const DetalhesAssinatura = () => {
  const [assinatura, setAssinatura] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const user = getAuth().currentUser;
  const db = getFirestore();

  useEffect(() => {
    const fetchAssinatura = async () => {
      try {
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();

          const dataInicio = userData.dataInicioAssinatura
            ? new Date(userData.dataInicioAssinatura).toLocaleDateString(
                'pt-BR'
              )
            : userData.createdAt
              ? new Date(userData.createdAt).toLocaleDateString('pt-BR')
              : 'N/A';

          const dataRenovacao = userData.dataRenovacaoAssinatura
            ? new Date(userData.dataRenovacaoAssinatura).toLocaleDateString(
                'pt-BR'
              )
            : 'N/A';

          setAssinatura({
            plano: userData.plano,
            dataInicio,
            dataRenovacao,
            status: userData.statusAssinatura || 'Ativo',
          });
        }
      } catch (error) {
        console.error(error);
        setError('Erro ao buscar os detalhes da assinatura.');
      } finally {
        setLoading(false);
      }
    };

    if (user) {
      fetchAssinatura();
    }
  }, [user, db]);

  if (loading) {
    return <div>Carregando...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="flex flex-col gap-4">
      <h3 className="text-xl font-semibold">Detalhes da Assinatura</h3>
      {assinatura ? (
        <div className="flex flex-col gap-3 bg-gray-50 p-4 rounded-lg border-l-4 border-teal-600">
          <div className="text-gray-700">
            <strong>Plano:</strong> {assinatura.plano}
          </div>
          <div className="text-gray-700">
            <strong>Data de Início:</strong> {assinatura.dataInicio}
          </div>
          <div className="text-gray-700">
            <strong>Data de Renovação:</strong> {assinatura.dataRenovacao}
          </div>
          <div className="text-gray-700">
            <strong>Status:</strong> {assinatura.status}
          </div>
        </div>
      ) : (
        <div className="text-red-500">Nenhuma assinatura encontrada.</div>
      )}

      {/* Substituindo o botão de "Cancelar Assinatura" pelo botão genérico */}
      <Button
        type="remover"
        label="Cancelar Assinatura"
        onClick={() => {
          // Lógica para cancelar a assinatura aqui
          console.log('Assinatura cancelada.');
        }}
        className=""
      />
    </div>
  );
};

export default DetalhesAssinatura;
